import { atom } from 'recoil';

export const businessType2 = atom({
  key: 'businessType2',
  default: "corporate",
});
